var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 41,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.5v40.1H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    d: "M55.7 40.1H-1.6V0h57.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffef00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M28.4 29.5v-.6l-.7-.8 1 .1.3-.9.5 1 .9.5-.7.5.2 1-.7-.6-.7.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M23.5 16.2c-.6.3-2.9 3-3.2 3.4a6 6 0 0 1-1.3 1.8q-1 .6-.8 1.6t.7 1.6q.3.3.7.4.6 0 .8.3c1 1.5 2.7 2.5 3.8 3.4q.8.3 1.4 1 .4 1 .2 1.5l-.8 3.2c-.2.9.6.7.6.5.4-.5.9-.1 1.6-2.7l1-1.3.4-.2c.6-.7.1-1.1-.2-1.3l-.7-.2-1-.9a15 15 0 0 0-3.5-4.6l-.9-.4q-.2-.2 0-.5l4.4-2.8.2-.1-.5-3-2.5-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffec00",
    fillRule: "evenodd",
    d: "m25.6 32.4 1.6-.4-.2.6-1.6.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M21.6 26.5a3 3 0 0 1 1.7-1.6m2.3 7.5.6-.2.4-.1.4-.1.4-.1m-2.1 1.4.2-.1.5-.2.4-.1.3-.1.4-.1m-1.2-6v.2l-.6.2h-.4m1 4.2h.8l.3.1h.4m0 0h.3zm-2.3 2.7.2-.2.5-.2.3-.1h.3l.4-.2m.4-3.2v.3l.5.3h.4m-9.7-7.3.1-.1.2-.2m1.1 1.9 1.5-.8.3-.3h.2l.1-.3.2-.2v-.3m1.7 1v.2l-.4.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m21.5 24.1.5.2 1.3.7.3.2.2.3.2.2 1 2 .2.2.1.2.3.2.3.2 1.3.8c.1 0 .5.4.2.7l-.2.2-.3.2h-1m-7-9 .2.2h.2l.5.2.3.3.4.1.4.1h.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe606",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M18.9 23h1.6q.5 0 .5-.3l.4-.4q.4 0 .4.2c.6.6.1 1.3.1 1.3q-.4.4-.6.1l-.4-.4H20l-.3.1-.5.2q-.4 0-.5-.2-.3-.5.2-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffef00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m36.3 9.5-.5.2-.4 1-.3-.9-1 .2.8-1-.1-1 .7.4.9-.6-.3.8.5.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M27.2 20.2c.5.4 4 1 4.4 1.2a6 6 0 0 1 2.3.2q1 .5 1.7 0 1-.7 1.1-1.5v-.8q-.2-.6 0-.9.9-2.6 1-4.9l.1-1.7q.5-.7 1.3-1l3.2-.8c.8-.3.3-.8.1-.8-.5 0-.5-.7-3.1 0l-1.7-.3-.3-.2c-1-.2-1 .4-1 .8l.1.7-.3 1.2c-.8 1-2 3.9-2.1 4.5 0 .5-.2.4-.2 1l.1 1q-.1.2-.4 0L29 15.6l-.3-.1-2.4 2 .5 2.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffec00",
    fillRule: "evenodd",
    d: "m40.2 10.5-1-1.2.6-.2 1.1 1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M37.1 16.9a3 3 0 0 1-2.2-.7m5.4-5.7-.5-.5-.3-.3-.3-.3-.3-.3m2.3 1.2-.2-.1-.4-.4-.3-.2-.2-.3-.3-.2M35.2 13h.1q.3 0 .5.3l.2.3v.1m3.2-3-.2-.4-.1-.3-.2-.3-.2-.3m0 0V9zm3.4.7-.2-.1-.4-.3-.2-.3-.3-.2-.2-.2m-3 1.1.2-.2v-.8l-.1-.1M36 21h-.1l-.3-.1m1-2-1.3-.8-.3-.1-.3-.1H34m0-1.9.3-.1h.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M35 18.1v-2.7l.2-.3 1.2-1.8V13q.3 0 .2-.2v-.3l.1-.4v-1.5q0-.5.5-.5h.4l.3.3q.5.5.5.7M34 21.7v-.4l-.1-.3v-1.3l-.2-.3-.2-.3.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe606",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m35.3 21-.3-1-.4-.6q-.3-.4-.5-.3l-.6-.1v-.5c.2-.8 1-.7 1-.7q.6.1.5.4l-.2.6c0 .3.4.8.4.8l.3.2.4.4q.3.3 0 .5-.1.5-.6.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffef00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m14.6 13.2.5.3 1-.3-.5.8.7.7H15l-.7.5-.2-.8-1-.3.8-.3.3-.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M28.6 15c0-.7-1.2-4-1.4-4.4a6 6 0 0 1-1-2q-.3-1.1-1-1.5-1-.3-1.9-.1l-.6.4c-.3.5-.5.4-.7.6-1.8.3-3.5 1.2-4.7 1.8q-.7.5-1.5.8-.8 0-1.5-.5L11.8 8c-.7-.5-.8.2-.7.3.2.5-.3.9 1.7 2.7l.7 1.5v.4c.3.9.9.6 1.2.4l.5-.5 1.2-.4c1.2.2 4.4-.4 4.9-.7s.5 0 .9-.3l.8-.7q.2 0 .3.3.1 2.5.5 5.1v.3l3 1 2-1.9-.1-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffec00",
    fillRule: "evenodd",
    d: "m13.3 9.4-.4 1.5-.4-.4.3-1.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M20.4 8.5c.6.6.8 1.7.6 2.2m-7.6-1.4-.2.7v.4l-.2.4v.4m-.4-2.6v1.2l-.1.4-.1.3m5.8 1.7q-.2-.3 0-.7v-.3l.2-.1M14 10v.1l-.2.3-.2.3-.2.3-.2.3-.1.2M12 8.2v1.1l-.2.3v.3m2.6 2q0-.2-.3-.2l-.4.3-.2.2-.1.1m11-5.2.1.1v.3m-2.1.1v1.7l.1.3v.3l.1.2.2.2.2.3m-1.6 1-.2-.2q-.4-.1-.4-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m22.6 9.5-.4.4-1.3.8-.3.2h-.3l-2.5.2h-.5l-.3.2-.3.1-1.4.8q-.3.2-.7-.1v-.7q0-.8.3-.8v-.1m11.2-2H26l-.3.3-.2.2-.2.1-.3.2-.3.2-.2.2-.2.4-.2.2m1 5.8v-2.7L25 13v-.4l-.2-.3V12l-.2-.3v-.2l-.2-.3-.1-.3-.1-.3v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe606",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m24.8 7.7-.5.8-.3.6q-.2.5 0 .6l.2.6q-.1.3-.3.3c-.8.3-1.2-.5-1.2-.6q-.2-.5.1-.5t.6-.2l.4-.8v-.9q.3-.4.5-.3.6 0 .5.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffef00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M23.7 15.6s2.3 1 2.7 1l2.3-1.8q0 .3.3.6l-2.1 1.8q-.2 1.3.3 3h-.5c-.5-.6-.7-3-.7-3l-2.4-1q.2-.2.1-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m26 18.1-.5.3a9 9 0 0 0-3.4 3l-.2.2-.2.3-.3.3m6.2-5.5.5.4c2 1.4 4 1.6 4.2 1.7h.6l.4.1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIm);
export default __webpack_public_path__ + "static/media/im.72e4a5402495423c0b4de455600739e5.svg";
export { ForwardRef as ReactComponent };